import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getStorageItem, setStorageItem } from "../utils/appStorage";

interface RankingContextValue {
  currentSlug: string;
  setCurrentSlug: (slug: string) => void;
}

const RankingContext = createContext<RankingContextValue | undefined>(undefined);

export const RankingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentSlug, setCurrentSlugState] = useState<string>(() => {
    return getStorageItem("currentRankingSlug") || "main";
  });

  useEffect(() => {
    setStorageItem("currentRankingSlug", currentSlug);
  }, [currentSlug]);

  const setCurrentSlug = useCallback((slug: string) => setCurrentSlugState(slug), []);

  const value = useMemo(
    () => ({ currentSlug, setCurrentSlug }),
    [currentSlug, setCurrentSlug]
  );

  return <RankingContext.Provider value={value}>{children}</RankingContext.Provider>;
};

export const useRanking = (): RankingContextValue => {
  const ctx = useContext(RankingContext);
  if (!ctx) throw new Error("useRanking must be used within RankingProvider");
  return ctx;
};


